var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "div",
            { staticClass: "section", staticStyle: { width: "100%" } },
            [
              _c(
                "div",
                { staticStyle: { "padding-top": "5px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.searchClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.purchaseClickHandler()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_PurchaseRegistration"))
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.delClickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "10px" },
                      model: {
                        value: _vm.filter.chkInvoice,
                        callback: function($$v) {
                          _vm.$set(_vm.filter, "chkInvoice", $$v)
                        },
                        expression: "filter.chkInvoice"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_ShowInvoiceDetails"))
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "padding-top": "10px" },
                  attrs: {
                    "label-width": "60px",
                    "label-position": "left",
                    inline: true
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_InvoiceType") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "150px" },
                          model: {
                            value: _vm.filter.invoiceType,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "invoiceType", $$v)
                            },
                            expression: "filter.invoiceType"
                          }
                        },
                        _vm._l(
                          _vm.InvoiceConstant.INVOICE_TYPES_HAS_ALL,
                          function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.language
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_TimeOfPurchase") }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "130px" },
                        attrs: {
                          "picker-options": _vm.pickerOptionsForBeginDate,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { change: _vm.changeBeginDate },
                        model: {
                          value: _vm.filter.beginDate,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "beginDate", $$v)
                          },
                          expression: "filter.beginDate"
                        }
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_To")) + " "),
                      _c("el-date-picker", {
                        staticStyle: { width: "130px" },
                        attrs: {
                          "picker-options": _vm.pickerOptionsForEndDate,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { change: _vm.changeEndDate },
                        model: {
                          value: _vm.filter.endDate,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "endDate", $$v)
                          },
                          expression: "filter.endDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "cargo-up-down-resize",
            {
              staticClass: "section",
              staticStyle: { height: "100%" },
              attrs: {
                "up-style": {
                  display: "flex",
                  flexDirection: "column",
                  paddingBottom: "5px"
                },
                "down-style": {
                  display: "flex",
                  flexDirection: "column",
                  paddingTop: "5px"
                }
              }
            },
            [
              _c("template", { slot: "up" }, [
                _c(
                  "div",
                  {
                    staticClass: "section grid-wrapper",
                    staticStyle: { "min-height": "350px" }
                  },
                  [
                    _c("cargo-ag-grid", {
                      key: "1906062",
                      staticStyle: { flex: "1" },
                      attrs: {
                        "config-module": "1906062",
                        "grid-params": _vm.gridParams,
                        "grid-options": _vm.gridOptions,
                        "column-defs": _vm.columnDefs,
                        "row-data": _vm.rowData
                      },
                      on: {
                        "update:gridParams": function($event) {
                          _vm.gridParams = $event
                        },
                        "update:grid-params": function($event) {
                          _vm.gridParams = $event
                        },
                        gridReady: _vm.onGridReady
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("template", { slot: "down" }, [
                _c(
                  "div",
                  {
                    staticClass: "section grid-wrapper",
                    staticStyle: { "min-height": "350px" }
                  },
                  [
                    this.filter.chkInvoice
                      ? _c("cargo-ag-grid", {
                          key: "1906063",
                          staticStyle: { flex: "1" },
                          attrs: {
                            "config-module": "1906063",
                            "grid-params": _vm.detail.gridParams,
                            "grid-options": _vm.detail.gridOptions,
                            "column-defs": _vm.detail.columnDefs,
                            "row-data": _vm.detail.rowData
                          },
                          on: {
                            "update:gridParams": function($event) {
                              return _vm.$set(_vm.detail, "gridParams", $event)
                            },
                            "update:grid-params": function($event) {
                              return _vm.$set(_vm.detail, "gridParams", $event)
                            },
                            gridReady: _vm.onDetailGridReady
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            2
          )
        ],
        1
      ),
      _vm.purchaseWindow.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.purchaseWindow.visible,
                title: _vm.$t("CargoMsg.Cargo_PurchaseRegistration"),
                width: "350px",
                "append-to-body": "",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.purchaseWindow, "visible", $event)
                },
                close: _vm.closePrchaseWindow
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "justify-content": "center" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_InvoiceType") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.purchaseWindow.form.invoiceType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.purchaseWindow.form,
                                    "invoiceType",
                                    $$v
                                  )
                                },
                                expression: "purchaseWindow.form.invoiceType"
                              }
                            },
                            _vm._l(_vm.InvoiceConstant.INVOICE_TYPES, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.language
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_1StInvoiceNo")
                          }
                        },
                        [
                          _c("el-input", {
                            ref: "txtStartInvoiceNo",
                            attrs: {
                              oninput: "value=value.replace(/[^A-Za-z0-9]/g,'')"
                            },
                            on: { blur: _vm.invoiceNoFocusOutHandler },
                            model: {
                              value: _vm.purchaseWindow.form.txtStartInvoiceNo,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.purchaseWindow.form,
                                  "txtStartInvoiceNo",
                                  $$v
                                )
                              },
                              expression:
                                "purchaseWindow.form.txtStartInvoiceNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_NumberOfCopies")
                          }
                        },
                        [
                          _c("el-input", {
                            ref: "txtQuantity",
                            attrs: {
                              oninput: "value=value.replace(/[^0-9]/g,'')"
                            },
                            on: { blur: _vm.invoiceNoFocusOutHandler },
                            model: {
                              value: _vm.purchaseWindow.form.txtQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.purchaseWindow.form,
                                  "txtQuantity",
                                  $$v
                                )
                              },
                              expression: "purchaseWindow.form.txtQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_LastInvoiceNo")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.purchaseWindow.form.txtEndInvoiceNo,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.purchaseWindow.form,
                                  "txtEndInvoiceNo",
                                  $$v
                                )
                              },
                              expression: "purchaseWindow.form.txtEndInvoiceNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_PurchasedBy") }
                        },
                        [
                          _c("cargo-user-select", {
                            ref: "userAuto",
                            attrs: {
                              "default-value":
                                _vm.purchaseWindow.form.userAuto || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.purchaseWindow.form.userAuto = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_TimeOfPurchase")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "purchasingDate",
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.purchaseWindow.form.purchasingDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.purchaseWindow.form,
                                  "purchasingDate",
                                  $$v
                                )
                              },
                              expression: "purchaseWindow.form.purchasingDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.purchaseWindow.saving,
                        type: "primary"
                      },
                      on: { click: _vm.okEvent }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                  ),
                  _c("el-button", { on: { click: _vm.closePrchaseWindow } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))
                  ])
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }